module.exports = __webpack_public_path__ + "static/img/vue-press.d1fed5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vue-press.png
// module id = LqYT
// module chunks = 1